import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation, Link } from "react-router-dom";
import {
  Card,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Spin,
  Typography,
} from "antd";
import dayjs from "dayjs";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import CustomButton from "../../../components/custom/CustomButton";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import { apiConfig, labelConfig, staticConfig } from "../teller.config";

const { Text } = Typography;

const DUMMY_STAFF_OPTIONS = [
  { value: 1, label: "146_DELETED_Test Head Teller" },
  { value: 2, label: "John Doe - Teller" },
  { value: 3, label: "Jane Smith - Senior Teller" },
];

const DUMMY_GL_OPTIONS = [
  { value: 101, label: "Cash in Vault (101)" },
  { value: 102, label: "Cash in Hand (102)" },
  { value: 103, label: "Teller GL Account (103)" },
];

const EditTeller = (props) => {
  const navigate = useNavigate();
  const { userData } = props;
  const { session } = userData;
  const { state } = useLocation();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(true);
  const [tellerDetails, setTellerDetails] = useState(false);
  const [staffOptions, setStaffOptions] = useState([]);

  const tillId = state?.tillId;
  const tellerId = state?.id;

  useEffect(() => {
    getTemplate();
    getTeller();
  }, []);

  const breadcrumbItems = [
    {
      title: <Link to="/tlo0100">{labelConfig.manageLinkUserToTill}</Link>,
    },
    {
      title: (
        <Link to="/detail-tlo0100" state={{ id: tillId }}>
          {labelConfig.manageLinkUserToTillTeller}
        </Link>
      ),
    },
    { title: labelConfig.editTeller },
  ];

  const getTemplate = () => {
    let body = {
      session,
    };

    const url = `${apiConfig.Customizedteller}/${tillId}/tellers/template`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = res;
        console.log(objList);
        let staffOptions = [];

        objList?.appUserDataOptions?.forEach((item) => {
          staffOptions.push({
            value: item.id,
            label: item.firstname + " " + item.lastname,
          });
        });

        setStaffOptions(staffOptions);
        setIsLoading(false);
      }
    });
  };

  const getTeller = () => {
    let body = {
      session,
    };

    const url = `${apiConfig.Customizedteller}/${tellerId}`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = res;
        console.log(objList);

        form.setFieldsValue({
          staffId: objList?.appUser?.id ?? null,
          description: objList?.description,
          isActive:
            objList?.status === "A"
              ? "Active"
              : objList?.status === "I"
                ? "Inactive"
                : null,
          startDate: dayjs(BOM.FormatArrayDate(objList?.startDate)) ?? null,
          endDate: dayjs(BOM.FormatArrayDate(objList?.endDate)) ?? null,
        });

        const tempTeller = {
          id: objList?.id,
          tillProfileId: objList?.tellerProfile?.id,
          userName: objList?.appUser?.username ?? "—",
          tellerDescription: objList?.description ?? "—",
          status:
            objList?.status === "A"
              ? "Active"
              : objList?.status === "I"
                ? "Inactive"
                : (objList?.status ?? "—"),
          startDate: BOM.FormatArrayDate(objList?.startDate),
          endDate: BOM.FormatArrayDate(objList?.endDate),
        };

        setTellerDetails(tempTeller);

        setIsLoading(false);
      }
    });
  };

  function onCancel() {
    navigate("/detail-tlo0100", { replace: false });
  }

  const onSubmit = () => {
    setIsLoading(true);
    setTimeout(() => {
      BOM.AlertMsg(cnt.SUCCESS, "Teller updated successfully");
      setIsLoading(false);
      navigate("/detail-tlo0100");
    }, 1500);
  };

  return (
    <MainLayout isEnableRightSidebar={false}>
      <TopContent
        pageTitle={`${labelConfig.editTeller}: ${tellerDetails?.userName}`}
        pageItems={breadcrumbItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <div
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#9ca3af",
                letterSpacing: 1,
                textTransform: "uppercase",
                marginBottom: 14,
              }}
            >
              Teller Information
            </div>

            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  name="staffId"
                  label={<Text strong>User's Name</Text>}
                  rules={[{ required: true, message: "Required Field" }]}
                >
                  <Select
                    placeholder="Select a user"
                    options={staffOptions}
                    showSearch
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    style={{ height: 44 }}
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="description"
                  label={<Text strong>Description</Text>}
                >
                  <Input
                    placeholder="Enter description"
                    style={{ height: 44 }}
                  />
                </Form.Item>
              </Col>

              {/* <Col span={8}>
                <Form.Item
                  name="tellerGlId"
                  label={<Text strong>Teller GL</Text>}
                  rules={[{ required: true, message: "Required Field" }]}
                >
                  <Select
                    placeholder="Select GL account"
                    options={DUMMY_GL_OPTIONS}
                    showSearch
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    style={{ height: 44 }}
                  />
                </Form.Item>
              </Col> */}

              <Col span={8}>
                <Form.Item
                  name="startDate"
                  label={<Text strong>From</Text>}
                  rules={[{ required: true, message: "Required Field" }]}
                >
                  <DatePicker style={{ width: "100%", height: 44 }} />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="endDate"
                  label={<Text strong>To</Text>}
                  rules={[{ required: true, message: "Required Field" }]}
                >
                  <DatePicker style={{ width: "100%", height: 44 }} />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="isActive"
                  label={<Text strong>Status</Text>}
                  rules={[{ required: true, message: "Required Field" }]}
                >
                  <Select
                    placeholder="Select status"
                    options={[
                      { label: "Active", value: true },
                      { label: "Inactive", value: false },
                    ]}
                    style={{ height: 44 }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Divider />
            <Row>
              <CustomButton
                content="Submit"
                htmlType="submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
              />
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});

export default connect(mapStateToProps, null)(EditTeller);
